<div class="about-wrapper" id="about-us">
  <div class="image-wrapper">
    <img src="../../assets/images/school-picture.png" alt="logo" />
    <div class="layer-2"></div>
  </div>
  <div class="message-wrapper">
    <h2>About Us</h2>
    <div class="text-wrap">
      <p>{{ school?.about }}</p>
      <h3>Mission and Vision</h3>
      <p>{{ school?.combinedVisionMission || combinedVisionMission }}</p>
    </div>
  </div>
</div>
